<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form>
        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.name"
          name="CatName"
          :label="$t('Name')"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('CatName')">{{
          errors.first("CatName")
        }}</span>

        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          :disabled="disabled"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";

const dict = {
  custom: {
    CatName: {
      required: "لطفا نام دپارتمان را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  props: {
    show: { default: false },
    model: {
      default: {},
    },
  },
  data() {
    return {
      CatName: "",
      popupTitle: "",
      disabled: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createCategory: "category/create",
      updateCategory: "category/update",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        this.disabled = true;
        if (result) {
          if (this.model.id != null) {
            this.updateCategory(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          } else {
            this.createCategory(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          }
        } else {
          // form have errors
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.disabled = false;

        if (this.model.id) this.popupTitle = "EditCategory";
        else this.popupTitle = "CreateNewCategory";
      }
      this.$validator.reset();
    },
  },
};
</script>
